import React from "react"
import * as styles from "./hero.module.css"
import {useScrollOpacity} from "../hooks/useScrollOpacity"

import heroImage from "../images/heros/allHands_Roach-4.jpg"

export default function Hero() {
	const opacity = useScrollOpacity()
	return (
		<section
			id="home"
			className={styles.indexHeroWrapper}
			style={{
				backgroundImage: `url(${heroImage})`,
			}}
		>
			<div className={styles.heroTextWrapper} style={{opacity}}>
				<h1 className={`${styles.heroTitle} heroTitle`}>Nate Weiner</h1>
				<p className={styles.indexHeroText}>
					<span>Composer • Software Engineer</span>
					<cite>Photo by Adam Roach</cite>
				</p>
			</div>
		</section>
	)
}
